import ReportsV2 from './ReportsV2'

export default ReportsV2
